import { cva, type VariantProps } from 'class-variance-authority';

export const cardVariants = cva('rounded-card border border-edge bg-surface', {
  variants: {
    isInteractive: { true: 'cursor-pointer transition-tone hover:bg-surface-hover', false: '' },
  },
  defaultVariants: { isInteractive: false },
});

export type CardVariants = VariantProps<typeof cardVariants>;
